export default "__VITE_ASSET__$vs7Zt9Q__"